import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { GROUP_ICONS_SVG } from "../assets/svg/group-icons.inline";
import { GROUP_BACKGROUND_SVG } from "../assets/svg/group-background.inline";
import { GROUP_IMAGES_SVG } from "../assets/svg/group-images.inline";
import { GROUP_VC_SVG } from "../assets/svg/group-vc.inline";

/**
 * Register the icon sets as literals (DEV-7562). A data: URL is still fetched through
 * HttpClient, and when that request fails - typically a page that is already being torn
 * down - every <mat-icon> on screen reports its own "Unable to find icon" error. A literal
 * needs no request at all, so it also stays clear of ad-blockers.
 */
export function registerIconSets( registry: MatIconRegistry, sanitizer: DomSanitizer ): void {

	registry.addSvgIconSetLiteralInNamespace( 'bg', sanitizer.bypassSecurityTrustHtml( GROUP_BACKGROUND_SVG ) );
	registry.addSvgIconSetLiteralInNamespace( 'icons', sanitizer.bypassSecurityTrustHtml( GROUP_ICONS_SVG ) );
	registry.addSvgIconSetLiteralInNamespace( 'vc', sanitizer.bypassSecurityTrustHtml( GROUP_VC_SVG ) );
	registry.addSvgIconSetLiteralInNamespace( 'images', sanitizer.bypassSecurityTrustHtml( GROUP_IMAGES_SVG ) );
}
